import { useContext } from 'react'

import { LinksRapidosContext } from '@presentation/contexts'

export const useLinksRapidos = () => {
  return useContext(LinksRapidosContext).service
}
